import React, { useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import { useHistory } from 'react-router';
import { DownloadIcon, PencilIcon, PlusIcon } from '@heroicons/react/outline';
import { Tooltip, Menu, Dropdown, notification } from 'antd';

import DeleteCard from './delete-card';
import CardHielocos from './card-hielocos';
import PrintableCard from './printableCard';

import { useReactToPrint } from 'react-to-print';
import { useDispatch } from 'react-redux';
import { finishLoading, startLoading } from '../../store/actions/loading';

const ActionContainer = ({ title, children, onClick = () => {} }) => (
  <Tooltip title={title}>
    <div
      onClick={(e) => onClick(e)}
      className="h-7 w-7 bg-gray-600 rounded-full text-white flex items-center justify-center cursor-pointer hover:scale-110 transform transition"
    >
      {children}
    </div>
  </Tooltip>
);

const CardActions = ({ card, isVisible, onExport = () => {} }) => {
  const [show, setShow] = useState(false);

  const Router = useHistory();

  const dispatch = useDispatch();

  const PrintableCardRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => {
      dispatch(startLoading());
      return PrintableCardRef.current;
    },
    onBeforePrint: () => dispatch(finishLoading()),
    onPrintError: () => {
      dispatch(finishLoading());

      notification.open({
        type: 'error',
        message: 'Ocurrio un error al imprimir la tarjeta.',
        placement: 'bottomRight'
      });
    },
  });

  const menu = (
    <Menu>
      <Menu.Item onClick={() => Router.push(`/card/${card.id}`)} key="edit">
        <div className="flex gap-1">
          <PencilIcon width={16} /> Editar
        </div>
      </Menu.Item>
      <Menu.Item key="Poaps">
        <CardHielocos card={card} />
      </Menu.Item>
      <Menu.Item key="delete">
        <DeleteCard card={card} />
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <div className="hidden md:flex gap-2">
        <AnimatePresence>
          {(isVisible || show) && (
            <>
              <motion.div
                initial={{ opacity: 0, translateY: 20 }}
                animate={{
                  opacity: 1,
                  translateY: 0,
                  transition: { duration: 0.1 },
                }}
                className="flex gap-2"
              >
                <ActionContainer title="Exportar" onClick={handlePrint}>
                  <DownloadIcon width={18} />
                </ActionContainer>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, translateY: 20 }}
                animate={{
                  opacity: 1,
                  translateY: 0,
                  transition: { delay: 0.1 },
                }}
                className="flex gap-2"
              >
                <ActionContainer>
                  <Dropdown
                    overlay={menu}
                    placement="topLeft"
                    trigger={['hover']}
                    onVisibleChange={(visible) => setShow(visible)}
                  >
                    <PlusIcon width={18} />
                  </Dropdown>
                </ActionContainer>
              </motion.div>
            </>
          )}
        </AnimatePresence>
      </div>
      <div className="flex gap-2 md:hidden">
        <div className="flex gap-2">
          <ActionContainer title="Exportar" onClick={handlePrint}>
            <DownloadIcon width={18} />
          </ActionContainer>
        </div>

        <div className="flex gap-2">
          <ActionContainer>
            <Dropdown
              overlay={menu}
              placement="topLeft"
              trigger={['click']}
            >
              <PlusIcon width={18} />
            </Dropdown>
          </ActionContainer>
        </div>
      </div>

      <div className="hidden">
        <PrintableCard card={card} ref={PrintableCardRef} />
      </div>
    </>
  );
};

export default CardActions;
